import { Add } from '@mui/icons-material'
import { IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { Editor } from '@tiptap/core'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import TextStyle from '@tiptap/extension-text-style'
import StarterKit from '@tiptap/starter-kit'
import { MenuButtonBold, MenuButtonItalic, MenuControlsContainer, MenuDivider, MenuSelectHeading, RichTextEditor, MenuButtonBulletedList } from 'mui-tiptap'
import { EditorProps } from '../../../definitions/report_builder/ReportBuilderDefinitions'
import ColorPicker from './ColorPicker'
import { ColorNormalizer } from './ColorNormalizer'
import Highlight from '@tiptap/extension-highlight'

const TextEditor = ({ column, onChange }: EditorProps<'text'>) => {
    const theme = useTheme()

    return (
        <div>
            <RichTextEditor
                extensions={[
                    StarterKit,
                    TextStyle,
                    Color,
                    ColorNormalizer,
                    Highlight.configure({
                        multicolor: true
                    }),
                    Link.configure({
                        openOnClick: false,
                        HTMLAttributes: {
                            style: `
                                color: ${theme.palette.primary.main};
                                text-decoration: underline;
                                cursor: pointer;
                            `
                        }
                    })
                ]}
                content={column.settings.content ?? ''}
                onUpdate={({ editor }) => {
                    onChange({ content: editor.getHTML() })
                }}
                renderControls={(editor: Editor) => (
                    <MenuControlsContainer>
                        <MenuSelectHeading />
                        <MenuDivider />
                        <MenuButtonBold style={{ border: `1px solid ${theme.palette.divider}` }} />
                        <MenuButtonItalic style={{ border: `1px solid ${theme.palette.divider}` }} />
                        <ColorPicker editor={editor} type='text' />
                        <ColorPicker editor={editor} type='background' tooltip='Highlight Text' />
                        <MenuButtonBulletedList style={{ border: `1px solid ${theme.palette.divider}` }} />
                        <MenuDivider />
                        <Tooltip title='Insert Placeholder' placement='top'>
                            <div>
                                <IconButton
                                    size='small'
                                    onClick={() => {
                                        editor.chain().focus().insertContent('@{placeholdername}').run()
                                    }}
                                    sx={{
                                        'color': 'text.secondary',
                                        'borderRadius': 1,
                                        'padding': '6px 12px',
                                        '&:hover': {
                                            backgroundColor: 'action.hover',
                                            borderRadius: 1
                                        }
                                    }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        <Add fontSize='small' />
                                        <Typography
                                            fontSize='small'
                                            sx={{
                                                lineHeight: 1,
                                                fontWeight: 500
                                            }}>
                                            Placeholder
                                        </Typography>
                                    </div>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </MenuControlsContainer>
                )}
                editorProps={{
                    attributes: {
                        style: 'min-height: 72px;'
                    }
                }}
            />
        </div>
    )
}

export default TextEditor
